<template>
  <section class="elecIndustrialPress">
    <div class="content">
      <section class="welcome-container">
        <img class="welcome" src="~assets/images/elecIndustrialPress/bg-welcome.png">
      </section>

      <section class="btn-container">
        <img class="button" src="~assets/images/elecIndustrialPress/main-btn.png" @click="inspectionAuthenticity">
      </section>
      <section class="publish-container">
        <img class="publish" src="~assets/images/elecIndustrialPress/bg-publish.png">
      </section>

    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  created() {
    let headHTML = document.getElementsByTagName('head')[0].innerHTML;
    headHTML += '<link rel="icon" href="">';
    document.getElementsByTagName('head')[0].innerHTML = headHTML;
    this.datas.jump_wxa.query = 'query=' + encodeURIComponent(this.$route.fullPath.split('?')[1] || '');
  },

  data() {
    return {
      datas: {
        loginSource: 'CYAN_GOURD',
        jump_wxa: {
          env_version: '',
          path: '/pagesB/childGradePic/index',
          query: ''
        }
      },
      locationURL: ''
    }
  },

  methods: {
    inspectionAuthenticity() {
      if (this.locationURL) {
        location.href = this.locationURL;
        return;
      }
      axios({
        url: 'https://fd.hollo-edu.com/hullo-cloud/client/login/getURLScheme',
        method: 'post',
        data: JSON.stringify(this.datas),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.code) {
          this.$message.error(res.message);
          return;
        }
        this.locationURL = res.data.data;
        location.href = this.locationURL;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.elecIndustrialPress {
  width: 100vw;
  height: 100vh;
  display: flex;
  background: url('~assets/images/elecIndustrialPress/bg-main-tic.png') no-repeat;
  background-size: contain;
  background-position: center;
  display: block;
  background-repeat: repeat;
  overflow: scroll;

  .content {
    margin: 0 auto;
    background: url('~assets/images/elecIndustrialPress/bg-main.png') no-repeat;
    background-size: contain;
    width: 100vw;
    height: 17rem;

    .welcome-container {
      padding-top: 1.4rem;

      .welcome {
        width: 79.73vw;
        height: 44.93vw;

      }
    }


    .btn-container {
      width: 100vw;
      height: 540px;
      display: flex;
      justify-content: center;
      margin-top: 9rem;

      .button {
        width: 58.93vw;
        height: 24vw;

      }
    }

    .publish-container {
      width: 100vw;
      display: flex;
      justify-content: center;

      .publish {
        width: 61.07vw;
        height: 6.53vw;
      }
    }


  }
}
</style>
